import { IFormPartnerMarketLeasing } from 'legacy/lut/classes/models/partner360/IFormPartnerMarketLeasing'
import { IPartnerMarketLeasing } from 'legacy/lut/features/partner360/marketInfo'

export const map1018ToMarketLeasing = (data: IFormPartnerMarketLeasing): IPartnerMarketLeasing => {
  return {
    entryId: data.EntryId,
    isLeasingOffer: typeof data.LeasingOffer === 'number' ? data.LeasingOffer === 1 : null,
    company1: data.LeasingCompany1,
    company2: data.LeasingCompany2,
    company3: data.LeasingCompany3,
    devicesFunded: data.DevicesFunded,
  }
}
